import { render, staticRenderFns } from "./BesFilter.vue?vue&type=template&id=063ea4e2&"
import script from "./BesFilter.vue?vue&type=script&lang=js&"
export * from "./BesFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports